const initialSearchDataState = {
  data : false,
  fullSearchData: false
}

export const SearchDataReducer = (state = initialSearchDataState, action = {}) => {

    switch (action.type) {
        case 'SEARCHDATA':
            return {
              ...state,
              data: action.dataForSearch

            }
        case 'SET_FULL_SEARCH_DATA':
            return {
                ...state,
                fullSearchData: action.payload
            }
        case 'DESTROY':
        case 'DESTROY_ADDRESSES': 
            return initialSearchDataState;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/SearchDataReducer.js